const COMPONENTS_VISIBLE = 'on-iphone-fullscreen'
const VIDEO_POSITIONING = 'on-video-position-called'
const SET_FULLSCREEN = 'on-set-fullscreen'
const SET_SEEK = 'on-set-seek'
const CHANGE_FULLSCREEN_VARIABLE = 'on-change-fullscreen-variable'
const CHECK_IF_MODAL = 'on-check-landscape-modal'
const CHANGE_GAME_ACTION = 'on-change-game_action'
const LOCKING_SCROLL_GLOBAL = 'on-scroll-lock'
const LOADING_COMPLETE = 'on-loading-complete'
const UNLOCKING_SCROLL_GLOBAL = 'on-scroll-unlock'
const VDOG_SWIPE_ACTION = 'on-vdog-swipe-action'
const VDOG_FLOATING_ACTION = 'on-vdog-floating-action'
const VSOCCER_SWIPE_ACTION = 'on-vsoccer-swipe-action'
const VSOCCER_FLOATING_ACTION = 'on-vsoccer-floating-action'
const VSOCCER_BETTING_FAILED = 'on-vsoccer-betting-failed'
const VSOCCER_CONFIRM_ACTIVE_STAKE = 'on-vsoccer-confirm-active-stake'
const VSOCCER_REMOVE_PICKED_MATCH = 'on-vsoccer-remove-stake'
const VSOCCER_SELECTED_STAKE = 'on-vsoccer-selected-stake'
const VSOCCER_CHANGE_PICKS_LENGTH = 'on-vsoccer-change-picks-length'
const VSOCCER_NEW_ROUND = 'on-vsoccer-new-round'
const VSOCCER_DISABLE_BETTING_MATCH = 'vsoccer-disable-betting-match'
const VSOCCER_TOGGLE_ASIDE_MENU_MOBILE = 'vsoccer-toggle-aside-menu-mobile'
const VSOCCER_GET_RESULT = 'vsoccer-get-result-data'
const VSOCCER_SHOW_MATCH_RESULT = 'vsoccer-on-show-match-result'
const VSOCCER_SHOW_ROTATION_MODAL = 'vsoccer-toggle-rotation-modal'
const VSOCCER_SHOW_API_ERROR = 'on-vsoccer-api-error'
const VSOCCER_SHOW_MAINTENANCE = 'on-vsoccer-maintenance'
const VSOCCER_TICKET_INSERTED = 'on-vsoccer-ticket-inserted'
const VSOCCER_TOGGLE_LEFT_MENU = 'vsoccer-toggle-left-menu'
const VSOCCER_SHOW_JACKPOT_VALUE = 'on-vsoccer-show-jackpot-value'
const VSOCCER_SHOW_NEW_SCORE = 'on-vsoccer-show-new-score'
const VSOCCER_REFRESH_ACTIVE_BETS = 'on-vsoccer-refresh-active-bets'
const VSOCCER_SHOW_RESULTS_HEADER = 'on-vsoccer-show-results-header'
const VSOCCER_TOTAL_ODDS = 'on-vsoccer-total-odds-change'
const VSOCCER_SHOW_BETTING_HISTORY = 'on-vsoccer-show-betting-history'
const VSOCCER_SHOW_TIMER = 'on-vsoccer-show-timer'
const VSOCCER_NUMBER_ACTIVE_TICKETS_LENGTH = 'vsoccer-number-active-tickets'
const VSOCCER_TIMER_TICK = 'vsoccer_timer_tick'
const VSOCCER_TIMER_TICK_TIMER = 'vsoccer_timer_tick_timer'
const VSOCCER_CONFIRM_MODAL_CLOSE = 'vsoccer_confirm_modal_close'
const VSOCCER_COMPONENT_LOAD_COMPLETE = 'vsoccer-component-loaded'
const VSOCCER_BETTING_HISTORY_REFRESH = 'vsoccer-betting_history_refresh'
const VSOCCER_SHOW_FALLEN_JACKPOTS = 'vsoccer-show-fallen-jackpots'
const VSOCCER_RESET_STAKE_CONFIRM = 'vsoccer-reset-stake-confirm'

const VDOG_SELECTED_STAKE = 'on-vdog-selected-stake'
const VDOG_SHOW_API_ERROR = 'on-vdog-api-error'
const VDOG_TICKET_INSERTED = 'on-vdog-ticket-inserted'
const VDOG_SHOW_JACKPOT_VALUE = 'on-vdog-show-jackpot-value'
const VDOG_SHOW_MATCH_RESULT = 'on-vdog-show-match-result'
const VDOG_SHOW_RESULTS_HEADER = 'on-vdog-show-results-header'
const VDOG_TOGGLE_LEFT_MENU = 'vdog-toggle-left-menu'
const VDOG_SHOW_MAINTENANCE = 'on-vdog-maintenance'
const VDOG_TIMER_TICK_TIMER = 'vdog_timer_tick_timer'
const VDOG_REFRESH_ACTIVE_BETS = 'on-vdog-refresh-active-bets'
const VDOG_SHOW_BETTING_HISTORY = 'on-vdog-show-betting-history'
const VDOG_TIMER = 'vdog_timer_tick'

const VDOG_NUMBER_ACTIVE_TICKETS_LENGTH = 'vdog-number-active-tickets'
const VDOG_CHANGE_PICKS_LENGTH = 'on-vdog-change-picks-length'
const VDOG_CONFIRM_ACTIVE_STAKE = 'on-vdog-confirm-active-stake'
const VDOG_CONFIRM_MODAL_CLOSE = 'vdog_confirm_modal_close'
const VDOG_CONFIRM = 'vdog_confirm_confirm'
const VDOG_RESET = 'vdog_confirm_reset'
const VDOG_RESET_AND_CLOSE = 'vdog_confirm_reset_and_close'
const VDOG_SHOW_FALLEN_JACKPOTS = 'vdog_show_fallen_jackpots'
const VDOG_COMPONENT_LOAD_COMPLETE = 'vdog-component-loaded'
const VDOG_BETTING_HISTORY_REFRESH = 'vdog-betting_history_refresh'

export default {
  VIDEO_POSITIONING: VIDEO_POSITIONING,
  COMPONENTS_VISIBLE: COMPONENTS_VISIBLE,
  SET_FULLSCREEN: SET_FULLSCREEN,
  SET_SEEK: SET_SEEK,
  CHANGE_FULLSCREEN_VARIABLE: CHANGE_FULLSCREEN_VARIABLE,
  CHECK_IF_MODAL: CHECK_IF_MODAL,
  CHANGE_GAME_ACTION: CHANGE_GAME_ACTION,
  LOCKING_SCROLL_GLOBAL: LOCKING_SCROLL_GLOBAL,
  LOADING_COMPLETE: LOADING_COMPLETE,
  UNLOCKING_SCROLL_GLOBAL: UNLOCKING_SCROLL_GLOBAL,
  VDOG_SWIPE_ACTION: VDOG_SWIPE_ACTION,
  VDOG_FLOATING_ACTION: VDOG_FLOATING_ACTION,
  VSOCCER_SWIPE_ACTION: VSOCCER_SWIPE_ACTION,
  VSOCCER_FLOATING_ACTION: VSOCCER_FLOATING_ACTION,
  VSOCCER_BETTING_FAILED: VSOCCER_BETTING_FAILED,
  VSOCCER_CONFIRM_MODAL_CLOSE: VSOCCER_CONFIRM_MODAL_CLOSE,
  VSOCCER_CONFIRM_ACTIVE_STAKE: VSOCCER_CONFIRM_ACTIVE_STAKE,
  VSOCCER_REMOVE_PICKED_MATCH: VSOCCER_REMOVE_PICKED_MATCH,
  VSOCCER_SELECTED_STAKE: VSOCCER_SELECTED_STAKE,
  VSOCCER_CHANGE_PICKS_LENGTH: VSOCCER_CHANGE_PICKS_LENGTH,
  VSOCCER_NUMBER_ACTIVE_TICKETS_LENGTH: VSOCCER_NUMBER_ACTIVE_TICKETS_LENGTH,
  VSOCCER_NEW_ROUND: VSOCCER_NEW_ROUND,
  VSOCCER_DISABLE_BETTING_MATCH: VSOCCER_DISABLE_BETTING_MATCH,
  VSOCCER_TOGGLE_ASIDE_MENU_MOBILE: VSOCCER_TOGGLE_ASIDE_MENU_MOBILE,
  VSOCCER_GET_RESULT: VSOCCER_GET_RESULT,
  VSOCCER_SHOW_MATCH_RESULT: VSOCCER_SHOW_MATCH_RESULT,
  VSOCCER_SHOW_ROTATION_MODAL: VSOCCER_SHOW_ROTATION_MODAL,
  VSOCCER_SHOW_API_ERROR: VSOCCER_SHOW_API_ERROR,
  VSOCCER_SHOW_MAINTENANCE: VSOCCER_SHOW_MAINTENANCE,
  VSOCCER_TICKET_INSERTED: VSOCCER_TICKET_INSERTED,
  VSOCCER_TOGGLE_LEFT_MENU: VSOCCER_TOGGLE_LEFT_MENU,
  VSOCCER_SHOW_JACKPOT_VALUE: VSOCCER_SHOW_JACKPOT_VALUE,
  VSOCCER_SHOW_NEW_SCORE: VSOCCER_SHOW_NEW_SCORE,
  VSOCCER_REFRESH_ACTIVE_BETS: VSOCCER_REFRESH_ACTIVE_BETS,
  VSOCCER_SHOW_RESULTS_HEADER: VSOCCER_SHOW_RESULTS_HEADER,
  VSOCCER_TOTAL_ODDS: VSOCCER_TOTAL_ODDS,
  VSOCCER_SHOW_BETTING_HISTORY: VSOCCER_SHOW_BETTING_HISTORY,
  VSOCCER_SHOW_TIMER: VSOCCER_SHOW_TIMER,
  VSOCCER_TIMER_TICK: VSOCCER_TIMER_TICK,
  VSOCCER_TIMER_TICK_TIMER: VSOCCER_TIMER_TICK_TIMER,
  VSOCCER_COMPONENT_LOAD_COMPLETE: VSOCCER_COMPONENT_LOAD_COMPLETE,
  VSOCCER_BETTING_HISTORY_REFRESH: VSOCCER_BETTING_HISTORY_REFRESH,
  VSOCCER_SHOW_FALLEN_JACKPOTS: VSOCCER_SHOW_FALLEN_JACKPOTS,
  VSOCCER_RESET_STAKE_CONFIRM: VSOCCER_RESET_STAKE_CONFIRM,
  // VDOG
  VDOG_SELECTED_STAKE: VDOG_SELECTED_STAKE,
  VDOG_SHOW_API_ERROR: VDOG_SHOW_API_ERROR,
  VDOG_TICKET_INSERTED: VDOG_TICKET_INSERTED,
  VDOG_SHOW_JACKPOT_VALUE: VDOG_SHOW_JACKPOT_VALUE,
  VDOG_SHOW_MATCH_RESULT: VDOG_SHOW_MATCH_RESULT,
  VDOG_SHOW_RESULTS_HEADER: VDOG_SHOW_RESULTS_HEADER,
  VDOG_TOGGLE_LEFT_MENU: VDOG_TOGGLE_LEFT_MENU,
  VDOG_SHOW_MAINTENANCE: VDOG_SHOW_MAINTENANCE,
  VDOG_TIMER_TICK_TIMER: VDOG_TIMER_TICK_TIMER,
  VDOG_TIMER: VDOG_TIMER,
  VDOG_REFRESH_ACTIVE_BETS: VDOG_REFRESH_ACTIVE_BETS,
  VDOG_SHOW_BETTING_HISTORY: VDOG_SHOW_BETTING_HISTORY,
  VDOG_NUMBER_ACTIVE_TICKETS_LENGTH: VDOG_NUMBER_ACTIVE_TICKETS_LENGTH,
  VDOG_CHANGE_PICKS_LENGTH: VDOG_CHANGE_PICKS_LENGTH,
  VDOG_CONFIRM_ACTIVE_STAKE: VDOG_CONFIRM_ACTIVE_STAKE,
  VDOG_CONFIRM_MODAL_CLOSE: VDOG_CONFIRM_MODAL_CLOSE,
  VDOG_CONFIRM: VDOG_CONFIRM,
  VDOG_RESET: VDOG_RESET,
  VDOG_SHOW_FALLEN_JACKPOTS: VDOG_SHOW_FALLEN_JACKPOTS,
  VDOG_COMPONENT_LOAD_COMPLETE: VDOG_COMPONENT_LOAD_COMPLETE,
  VDOG_BETTING_HISTORY_REFRESH: VDOG_BETTING_HISTORY_REFRESH,
  VDOG_RESET_AND_CLOSE: VDOG_RESET_AND_CLOSE
}
